import { Injectable, inject } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, catchError, switchMap, throwError } from "rxjs";
import { AuthService, UNAUTHENTICATED_RESPONSE_MESSAGES } from "../services/auth.service";
import { TranslateService } from "@ngx-translate/core";
import { AUTH_API } from "../apis/auth.api";
import { DEFAULT_PEOPLE_MATE_LANGUAGE } from "src/app/shared/constants/languages";
import { ValidateOTPResponse } from "src/app/modules/authentication/pages/user-otp/user-otp.component";
import { ErrorModel } from "./error.interceptor";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private authService = inject(AuthService);
  private translateService = inject(TranslateService);


  getUserLanguage(): string {
    this.translateService.currentLang;
    return this.translateService.currentLang || DEFAULT_PEOPLE_MATE_LANGUAGE.code;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.UserToken;
    const userId = this.authService.User?.id || 0;
    if (
      !request.url.startsWith("http") &&
      !request.url.startsWith("https") &&
      !request.url.includes("assets") &&
      !request.url.includes(AUTH_API.LOGIN) &&
      !request.url.includes(AUTH_API.VALIDATE_OTP(userId)) &&
      !request.url.includes(AUTH_API.REFRESH_ACCESS_TOKEN) &&
      token
    ) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": this.getUserLanguage(),
        },
      });
    }
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const error_response: ErrorModel = error.error;
        if (
          error.status === 403 &&
          token &&
          this.authService.User &&
          (error_response.message === UNAUTHENTICATED_RESPONSE_MESSAGES.refresh_expired ||
            error_response.detail === UNAUTHENTICATED_RESPONSE_MESSAGES.refresh_blocked ||
            error_response.detail === UNAUTHENTICATED_RESPONSE_MESSAGES.access_expired)
        ) {
          return this.authService.refreshToken().pipe(
            switchMap((response: { access: string; refresh: string }) => {
              this.authService.User = {
                ...this.authService.User,
                access: response.access,
                refresh: response.refresh,
              } as ValidateOTPResponse;
              request = request.clone({
                setHeaders: {
                  Authorization: `Bearer ${response.access}`,
                  "Accept-Language": this.getUserLanguage(),
                },
              });
              return next.handle(request);
            }),
            catchError(refreshError => {
              return throwError(() => refreshError);
            }),
          );
        } else {
          return throwError(() => error);
        }
      }),
    );
  }
}
